<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('vns.ranges.form.fields.inicio')" label-for="input-start">
          <b-form-input id="input-start" v-model="range.start_value" type="number" step="0.01"/>
        </b-form-group>
        <b-form-group :label="$t('vns.ranges.form.fields.final')" label-for="input-end">
          <b-form-input id="input-end" v-model="range.end_value" type="number" step="0.01"/>
        </b-form-group>
        <b-form-group
            :label="$t('vns.ranges.form.fields.fundo.label')"
            label-for="input-bg-color"
            :description="$t('vns.ranges.form.fields.fundo.description')"
        >
          <b-form-input id="input-bg-color" v-model="range.background_color" type="color"/>
        </b-form-group>
        <b-form-group
            :label="$t('vns.ranges.form.fields.escrita.label')"
            label-for="input-text-color"
            :description="$t('vns.ranges.form.fields.escrita.description')"
        >
          <b-form-input id="input-text-color" v-model="range.font_color" type="color"/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('vns.ranges.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import RangesRepository from '@/repositories/vns/RangeRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      range: 'ranges/current',
      isLoading: 'ranges/isLoading'
    }),
    pageTitle() {
      if (this.range_id) return this.$t('vns.ranges.form.titulo_pagina.editar')
      return this.$t('vns.ranges.form.titulo_pagina.criar')
    }
  },
  data() {
    return {
      range_id: null
    }
  },
  methods: {
    ...mapActions([
      'ranges/listOne'
    ]),
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      RangesRepository.post(this.range).then(() => {
        this.$snotify.success(this.$t('vns.ranges.form.create.success'))
        this.$router.push({name: 'vns.ranges'})
      }).catch(error => {
        this.$snotify.error(this.$t('vns.ranges.form.create.error'))
        if (error.response.status === 422) {
          RangesRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      RangesRepository.put(this.range_id, this.range).then(() => {
        this.$snotify.success(this.$t('vns.ranges.form.update.success'))
        this.$router.push({name: 'vns.ranges'})
      }).catch(error => {
        this.$snotify.error(this.$t('vns.ranges.form.update.error'))
        if (error.response.status === 422) {
          RangesRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    if (this.$route.params.id) {
      this.range_id = this.$route.params.id
      await this['ranges/listOne'](this.$route.params.id)
    }
  }
}
</script>

<style scoped>
</style>
